export const pessoaModel = {
  pessoa: function () {
    return {
      id: '',
      nome: '',
      cpfcnpj: '',
      tipo: '',
      pessoafisica: {
        id: '',
        dtnascimento: '',
        rg: '',
        tpestcivil: '',
        tpgenero: ''          
      },
      pessoajuridica: {
        id: '',
        razaosocial: '',
        dtfundacao: '',
        inscestadual: '',
      },
      enderecos: [],
      telefones: [],
      emails: []
    }
  },
}


// WEBPACK FOOTER //
// ./src/models/pessoa.js